import http, { url } from '../../http'

const API_URL = "raei-report"

/** Ítem 3.2.3 — Reporte estadístico anual (RAEI) branded firmable, anclado por empresa + año. */
class RaeiReportAPI {

  // Datos del reporte anual (matriz mensual + KPIs + semáforos) para la vista.
  async data(companyId, year) {
    const response = await http(`${API_URL}/${companyId}/${year}/data`, 'GET')
    return response || null
  }

  // PDF branded firmable (se descarga por navegación directa).
  pdfUrl(companyId, year) {
    return url(`${API_URL}/${companyId}/${year}/pdf`)
  }

  async status(companyId, year) {
    return await http(`${API_URL}/${companyId}/${year}/status`, 'GET')
  }

  async sign(companyId, year, payload) {
    return await http(`${API_URL}/${companyId}/${year}/sign`, 'POST', payload)
  }
}

export default new RaeiReportAPI()
